(async function () {
  const url = new URL(location.href);
  const order = url.searchParams.get('sort_by');
  const brand = url.searchParams.get('fsd_brand') || '';
  const needSelect = document.querySelector('select[name="fsd_need"]');
  const needMapNode = document.querySelector('[data-needs-map]');
  const needsMap = needMapNode ? JSON.parse(needMapNode.textContent) : null;
  const requestedNeed = url.searchParams.get('fsd_need') || '';
  const need = needsMap && Object.hasOwn(needsMap, requestedNeed) ? requestedNeed : '';
  if (needSelect) needSelect.value = need;
  const brandSelect = document.querySelector('select[name="fsd_brand"]');
  if (brandSelect) brandSelect.value = brand;
  const section = document.getElementById('CollectionSection');
  if (!section) return;
  const grid = section.querySelector('.grid-uniform');
  const status = document.getElementById('fsd-sort-status');
  const pageSize = Number(section.dataset.pageSize);
  const requestedPage = Math.max(1, Math.floor(Number(url.searchParams.get('page')) || 1));
  if (!grid || !pageSize || !status) return;
  const priceOrder = order === 'price-ascending' || order === 'price-descending';
  const stockFirst = !order || order === 'manual' || order === 'best-selling';
  const cache = new Map();
  status.hidden = false;
  grid.setAttribute('aria-busy', 'true');
  try {
    async function readPage(page, availability) {
      const key = `${availability ?? 'all'}:${page}`;
      if (cache.has(key)) return cache.get(key);
      const request = new URL(url);
      request.searchParams.set('view', 'fsd-price-data');
      request.searchParams.set('page', String(page));
      request.searchParams.delete('fsd_brand');
      request.searchParams.delete('fsd_need');
      if (availability !== undefined) request.searchParams.set('filter.v.availability', availability);
      const pending = (async () => {
        const response = await fetch(request, {credentials: 'same-origin'});
        if (!response.ok) throw new Error('Catalog unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const root = doc.querySelector('[data-price-pages]');
        if (!root) throw new Error('Catalog incomplete');
        const count = Number(root.dataset.priceCount);
        const cards = Array.from(root.querySelectorAll('[data-product-id]'));
        if (!Number.isInteger(count) || count < 0) throw new Error('Invalid count');
        if (availability !== undefined && cards.some(card => card.dataset.available !== (availability === '1' ? 'true' : 'false'))) throw new Error('Availability filter unavailable');
        return {count, pages: Number(root.dataset.pricePages), cards};
      })();
      cache.set(key, pending);
      return pending;
    }
    async function readSlice(start, end, availability) {
      if (end <= start) return [];
      const firstPage = Math.floor(start / 250) + 1;
      const lastPage = Math.floor((end - 1) / 250) + 1;
      const chunks = await Promise.all(Array.from({length: lastPage - firstPage + 1}, (_, i) => readPage(firstPage + i, availability)));
      return chunks.flatMap(chunk => chunk.cards).slice(start % 250, start % 250 + end - start);
    }
    let count;
    let currentPage;
    let visible;
    if (brand || priceOrder || needsMap) {
      const first = await readPage(1);
      const roots = [first];
      for (let page = 2; page <= first.pages; page += 2) {
        roots.push(...await Promise.all(Array.from({length: Math.min(2, first.pages - page + 1)}, (_, i) => readPage(page + i))));
      }
      let cards = roots.flatMap(root => root.cards);
      if (cards.length !== first.count || new Set(cards.map(card => card.dataset.productId)).size !== first.count) throw new Error('Catalog incomplete');
      if (brand) cards = cards.filter(card => card.dataset.vendor === brand);
      if (needsMap && needSelect) {
        for (const option of needSelect.options) {
          if (!option.value) continue;
          const ids = new Set(needsMap[option.value]);
          const matching = cards.filter(card => ids.has(card.dataset.productId)).length;
          option.textContent += ` (${matching})`;
          option.hidden = matching === 0 && option.value !== need;
          option.disabled = matching === 0 && option.value !== need;
        }
        if (need) {
          const ids = new Set(needsMap[need]);
          cards = cards.filter(card => ids.has(card.dataset.productId));
        }
        needSelect.disabled = false;
        needSelect.closest('fieldset').hidden = false;
        const notice = section.querySelector('[data-needs-notice]');
        if (notice) notice.hidden = false;
      }
      if (brand || need) {
        const stockInputs = Array.from(section.querySelectorAll('input[name="filter.v.availability"]'));
        stockInputs.forEach(input => {
          const available = input.value === '1';
          const matching = cards.filter(card => (card.dataset.available === 'true') === available).length;
          const label = input.closest('label');
          if (!label) return;
          Array.from(label.childNodes).filter(node => node.nodeType === 3).forEach(node => { node.textContent = node.textContent.replace(/\(\d+\)/, `(${matching})`); });
          label.hidden = !matching && !input.checked;
        });
        if (stockInputs.length && !stockInputs.some(input => input.checked)) {
          const useful = stockInputs.filter(input => !input.closest('label').hidden).length > 1;
          stockInputs[0].closest('fieldset').hidden = !useful;
        }
      }
      if (priceOrder) {
        const price = card => Number(card.querySelector('[data-display-price]')?.dataset.displayPrice);
        if (cards.some(card => !Number.isFinite(price(card)))) throw new Error('Price unavailable');
        const direction = order === 'price-ascending' ? 1 : -1;
        cards.sort((a, b) => direction * (price(a) - price(b)) || a.dataset.productId.localeCompare(b.dataset.productId));
      } else if (stockFirst) {
        cards.sort((a, b) => Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true'));
      }
      count = cards.length;
      currentPage = Math.min(requestedPage, Math.max(1, Math.ceil(count / pageSize)));
      visible = cards.slice((currentPage - 1) * pageSize, currentPage * pageSize);
    } else if (stockFirst && url.searchParams.getAll('filter.v.availability').length !== 1) {
      const [available, unavailable] = await Promise.all([readPage(1, '1'), readPage(1, '0')]);
      count = available.count + unavailable.count;
      currentPage = Math.min(requestedPage, Math.max(1, Math.ceil(count / pageSize)));
      const start = (currentPage - 1) * pageSize;
      const end = Math.min(start + pageSize, count);
      const groups = await Promise.all([
        readSlice(Math.min(start, available.count), Math.min(end, available.count), '1'),
        readSlice(Math.max(0, start - available.count), Math.max(0, end - available.count), '0')
      ]);
      visible = groups.flat();
    } else {
      const first = await readPage(1);
      count = first.count;
      currentPage = Math.min(requestedPage, Math.max(1, Math.ceil(count / pageSize)));
      visible = await readSlice((currentPage - 1) * pageSize, Math.min(currentPage * pageSize, count));
    }
    if (visible.length !== Math.min(pageSize, Math.max(0, count - (currentPage - 1) * pageSize))) throw new Error('Incomplete page');
    if (currentPage !== requestedPage) {
      if (currentPage === 1) url.searchParams.delete('page');
      else url.searchParams.set('page', String(currentPage));
      history.replaceState(history.state, '', url);
    }
    grid.replaceChildren(...visible);
    if (!count) {
      const empty = document.createElement('p');
      empty.textContent = section.dataset.noMatches || 'Nessun prodotto corrisponde ai filtri selezionati.';
      grid.append(empty);
    }
    let selected = false;
    try { selected = sessionStorage.getItem('fsd-extra30-selected') === 'true'; } catch (_) {}
    grid.querySelectorAll('.js-extra30-coupon').forEach(input => { input.checked = input.checked || selected; });
    section.querySelectorAll('nav.pagination').forEach(nav => {
      const wrapper = nav.closest('.pagination-border-top');
      if (wrapper) wrapper.remove(); else nav.remove();
    });
    const total = Math.ceil(count / pageSize);
    if (total > 1) {
      const nav = document.createElement('nav');
      nav.className = 'pagination text-center pagination-border-top';
      nav.setAttribute('aria-label', section.dataset.paginationLabel || 'Paginazione');
      nav.style.cssText = 'clear:both;margin:24px 0;display:flex;flex-wrap:wrap;justify-content:center;gap:8px';
      const pageNumbers = Array.from(new Set([1, currentPage - 1, currentPage, currentPage + 1, total])).filter(page => page >= 1 && page <= total).sort((a,b) => a-b);
      const addLink = (page, label) => {
        const link = document.createElement('a');
        const target = new URL(url);
        if (page === 1) target.searchParams.delete('page'); else target.searchParams.set('page', String(page));
        link.href = target.href;
        link.textContent = label;
        link.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;min-width:44px;min-height:44px;border:1px solid #b4ceca;border-radius:6px;padding:6px';
        if (page === currentPage) { link.setAttribute('aria-current', 'page'); link.style.fontWeight = '700'; link.style.background = '#e4f1eb'; }
        nav.append(link);
      };
      if (currentPage > 1) addLink(currentPage - 1, '←');
      pageNumbers.forEach((page, i) => {
        if (i && page > pageNumbers[i-1] + 1) { const gap = document.createElement('span'); gap.textContent = '…'; nav.append(gap); }
        addLink(page, String(page));
      });
      if (currentPage < total) addLink(currentPage + 1, '→');
      grid.after(nav);
    }
    status.hidden = true;
  } catch (error) {
    status.textContent = status.dataset.error;
  } finally {
    grid.removeAttribute('aria-busy');
  }
})();
